import { Controller } from '@hotwired/stimulus';
import { splitTestEnabled, getWindowWidth } from 'lib/helpers';

export default class StickyAdContainerController extends Controller {
  connect() {
    if (this.showStickyAd()) return;

    this.destroyElement();
  }

  destroyElement() {
    this.element.remove();
  }

  showStickyAd() {
    if (splitTestEnabled('no_pro_toast') && this.isWideVersion && !this.isCustomSalesEventActive) {
      return true;
    }

    return getWindowWidth() > 1399;
  }

  get isCustomSalesEventActive() {
    return document.body.classList.contains('custom-sales-event-active');
  }

  get isWideVersion() {
    // this only exists due to no_pro_toast needing a special variant
    // within the test. When test is finished, find better way to
    // determine this state.
    return document.body.dataset.noProToastTestWide === 'true';
  }
}
